var _ = require('underscore/underscore');

var Base = require('front/components/Base/Base');
var Utils = require('front/utils/Utils');

module.exports = Base.extend({
    // Тип страницы, используется для поиска активного элемента меню
    type: '',

    // Заголовок страницы
    title: undefined,

    setTitle: function (title) {
        title = title || this.title;
        if (title !== undefined) {
            document.title = title ? $('<div>' + title + '</div>').text() : '';
        }
    },

    $parent: function () {
        return app.els.$content;
    },

    activate: function (params) {
        this.setTitle();

        return Base.prototype.activate.call(this, params);
    }

});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Page/Page.js
// module id = 7
// module chunks = 0